import {
  Box,
  Card,
  CardContent,
  IconButton,
  Typography,
  Avatar,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";
import { useTheme } from "@mui/material/styles";

const AddTrainingCard = ({ handleAddTrainingClick }) => {
  const theme = useTheme();
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "12px",
        border: "1px dashed",
        borderColor: theme.customColors.border.dashed,
        backgroundColor: theme.customColors.background.hover,
        "&:hover": { background: theme.customColors.background.cardHeader },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
        }}
      >
        <LocalLibraryOutlinedIcon
          sx={{
            color: theme.customColors.text.secondary,
            fontSize: 40,
            padding: "4px",
          }}
        />

        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          sx={{ maxWidth: 400, lineHeight: 1.5 }}
        >
          Draft training courses from our master library or create custom
          courses manually.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon sx={{ fontSize: 16 }} />}
          onClick={handleAddTrainingClick}
          sx={{
            fontWeight: 500,
            fontSize: "14px",
            px: 2,
            py: 1,
          }}
        >
          Add Training Courses
        </Button>
      </CardContent>
    </Card>
  );
};

export default AddTrainingCard;
